import '../css/AddNursing.css'

import { Fragment, useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { Button, Col, DatePicker, Input, message, Modal, Row, Select, Space, Form } from "antd"
import { useForm } from "antd/lib/form/Form"
import { baseAxiosComplete, baseAxiosNoInfo } from "../../../tool/axios"
import _ from 'lodash'

const { Option } = Select

const formItemLayout = {
    labelCol: { span: 3 },
    wrapperCol: { span: 12 },
};

interface Prop {
    onChange?: () => void
}

interface Client {
    check_in_user_name: string // 客人姓名
    check_in_phone: string // 手机号码
    preg_status_desc: string // 怀孕时期
    expect_born_day: string // 预产期
    actually_born_day: string // 分娩日
    check_in_time: string // 实际入住时间
    check_out_time_init: string // 预计出所时间
    check_out_time_finally: string // 实际出所时间
    emergency_man_name: string // 紧急联系人
    emergency_phone: string // 紧急联系人手机号
    accompany_man_name: string // 陪护人
    accompany_phone: string // 陪护人手机号
    check_in_total_days: number // 入住总天数
    check_in_already_days: number // 已入住天数
    check_in_left_days: number // 剩余天数
}

interface Nursing {
    "nursing_id": string // 护理师标识
    "nursing_name": string // 护理师名称
    "work_years_type": string // 工作经验
    "service_start_date": string // 服务开始日期
    "service_end_date": string // 服务结束日期
    "service_days": number // 服务天数
    "reserve_customer_list": { // 预定客户集合
        "customer_name": string
        "remark": string
    }[]
    "service_customer_list": { // 服务客户集合
        "customer_name": string
        "remark": string
    }[]
}

export default function (prop: Prop) {

    const param: { id: string } = useParams()

    const [visible, setVisible] = useState<boolean>(false)
    const [clientData, setClientData] = useState<Client>()

    const [form] = useForm()

    const [currentID, setCurrentId] = useState<string>()
    const [serviceStartDate, setServiceStartDate] = useState<string>()
    const [serviceEndDate, setServiceEndDate] = useState<string>()
    const [serviceDays, setServiceDays] = useState<number>()

    const [nursingData, setNursingData] = useState<Nursing[]>([])

    useEffect(() => {
        getClientInfo()
    }, [])

    const getClientInfo = () => {
        baseAxiosNoInfo('/keeper/check_in/detail/base_info', {
            params: {
                check_in_id: param.id
            }

        }).then((res: any) => {
            if (res) {
                setClientData(res)
            }
        })
    }

    const onFetchNursing = () => {
        if (!form.getFieldValue('nursing_care_type')) {
            message.error('请填写护理模式')
            return
        }

        if (!form.getFieldValue('service_date')) {
            message.error('请选择服务日期')
            return
        }

        if (!form.getFieldValue('service_days')) {
            message.error('请填写服务天数')
            return
        }

        baseAxiosNoInfo('/yuesao_center/customer/clubhouse/query_distribute_nursing', {
            params: {
                check_in_id: param.id,
                service_date: form.getFieldValue('service_date').format('YYYY-MM-DD'),
                service_days: form.getFieldValue('service_days'),
                nursing_care_type: form.getFieldValue('nursing_care_type'),
                nursing_name: form.getFieldValue('nursing_name')
            }

        }).then((res: any) => {
            if (res) {
                res && setNursingData(res)

                if (res.length === 0) {
                    message.warn('暂无护理师可分配')
                }

            } else {
                message.error('请选择正确的服务信息')
            }
        })
    }

    // 提交
    const onFinish = () => {
        if (!currentID) {
            message.error('必须选择护理师才能提交')
            return
        }

        baseAxiosComplete.post('/yuesao_center/customer/clubhouse/distribute_nursing', {
            check_in_id: param.id,
            nursing_care_type: form.getFieldValue('nursing_care_type'),
            belong_nursing_id: currentID,
            service_start_date: form.getFieldValue('service_date').format('YYYY-MM-DD HH:mm:ss'),
            service_end_date: serviceEndDate,
            service_days: serviceDays

        }).then((res: any) => {
            if (res.status === 0) {
                setVisible(false)
                if (prop.onChange) prop.onChange()
            }
        })
    }

    return <Fragment>
        {/* 月嫂中心 -> 会所客户管理 -> 客户详情 -> 分配护理师 */}
        <Button type="primary" style={{ marginLeft: 16, marginBottom: 16 }} size="small" onClick={() => { setVisible(true) }}>分配护理师</Button>

        <Modal zIndex={1} title="分配护理师" width={1100} visible={visible} onCancel={() => { setVisible(false) }} onOk={onFinish}>
            <Row>
                <Col span={6}>
                    <div>
                        <Space>
                            <p>客人姓名：</p>
                            <p>{clientData?.check_in_user_name}</p>
                        </Space>
                    </div>
                    <div>
                        <Space>
                            <p>手机号码：</p>
                            <p>{clientData?.check_in_phone}</p>
                        </Space>
                    </div>
                    <div>
                        <Space>
                            <p>怀孕时期：</p>
                            <p>{clientData?.preg_status_desc}</p>
                        </Space>
                    </div>
                    <div>
                        <Space>
                            <p>预产期/分娩日：</p>
                            <p>{clientData?.expect_born_day}/{clientData?.actually_born_day}</p>
                        </Space>
                    </div>
                </Col>

                <Col span={6}>
                    <div>
                        <Space>
                            <p>实际入住日期：</p>
                            <p>{clientData?.check_in_time}</p>
                        </Space>
                    </div>
                    <div>
                        <Space>
                            <p>预计出所日期：</p>
                            <p>{clientData?.check_out_time_init}</p>
                        </Space>
                    </div>
                    <div>
                        <Space>
                            <p>实际出所日期：</p>
                            <p>{clientData?.check_out_time_finally}</p>
                        </Space>
                    </div>
                </Col>

                <Col span={6}>
                    <div>
                        <Space>
                            <p>陪护人：</p>
                            <p>{clientData?.accompany_man_name}</p>
                        </Space>
                    </div>
                    <div>
                        <Space>
                            <p>陪护人手机：</p>
                            <p>{clientData?.accompany_phone}</p>
                        </Space>
                    </div>
                    <div>
                        <Space>
                            <p>紧急联系人：</p>
                            <p>{clientData?.emergency_man_name}</p>
                        </Space>
                    </div>
                    <div>
                        <Space>
                            <p>紧急联系人手机：</p>
                            <p>{clientData?.emergency_phone}</p>
                        </Space>
                    </div>
                </Col>

                <Col span={6}>
                    <div>
                        <Space>
                            <p>预住总天数：</p>
                            <p>{clientData?.check_in_total_days}</p>
                        </Space>
                    </div>
                    <div>
                        <Space>
                            <p>已入住天数：</p>
                            <p>{clientData?.check_in_already_days}</p>
                        </Space>
                    </div>
                    <div>
                        <Space>
                            <p>剩余天数：</p>
                            <p>{clientData?.check_in_left_days}</p>
                        </Space>
                    </div>
                </Col>
            </Row>

            <Row>
                <Col span={24}><h3 style={{ color: 'red' }}>护理师筛选</h3></Col>
                <Col span={24}>
                    <Form onFinish={onFetchNursing} form={form} {...formItemLayout} layout="inline">
                        <Col span={12} style={{ marginBottom: '15px' }}>
                            <Form.Item label="服务日期" name="service_date" >
                                <DatePicker showTime style={{ width: '100%' }} />
                            </Form.Item>
                        </Col>
                        <Col span={12} style={{ marginBottom: '15px' }}>
                            <Form.Item label="服务天数" name="service_days" >
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col span={12} style={{ marginBottom: '15px' }}>
                            <Form.Item label="护理模式" name="nursing_care_type">
                                <Select>
                                    <Option value={1} key={1}>一对一</Option>
                                    <Option value={2} key={2}>托管</Option>
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span={12} style={{ marginBottom: '15px' }}>
                            <Form.Item label="护理师" name="nursing_name" >
                                <Input />
                            </Form.Item>
                        </Col>

                        <Col span={24} style={{ marginBottom: '15px' }}>
                            <Form.Item>
                                <Button type="primary" htmlType="submit">查询护理师</Button>
                            </Form.Item>
                        </Col>
                    </Form>
                </Col>
            </Row>

            <div>
                <div className="clear">
                    {nursingData.map(el => <div className={el.nursing_id === currentID ? "room-items active" : "room-items"} style={{ width: 220, height: 230 }} onClick={() => {
                        setCurrentId(el.nursing_id)
                        setServiceStartDate(el.service_start_date)
                        setServiceEndDate(el.service_end_date)
                        setServiceDays(el.service_days)
                    }}>
                        <p>护理师：{el.nursing_name}</p>
                        <p>从{el.service_start_date}</p>
                        <p>到{el.service_end_date}</p>
                        <p>可服务{el.service_days}天</p>

                        {
                            el.service_customer_list.length > 0 ? <h3 style={{ color: 'red' }}>已服务客户</h3> :
                                el.reserve_customer_list.length > 0 ? <h3 style={{ color: 'red' }}>已预定客户</h3> : ''
                        }

                        {
                            el.service_customer_list.length > 0 ? el.service_customer_list.map(occupy =>
                                <div style={{ padding: '2px 5px' }}>
                                    <p>{occupy.customer_name}：{occupy.remark}</p>
                                </div>
                            ) :
                                el.reserve_customer_list.length > 0 ? el.reserve_customer_list.map(occupy =>
                                    <div style={{ padding: '2px 5px' }}>
                                        <p>{occupy.customer_name}：{occupy.remark}</p>
                                    </div>
                                ) : ''
                        }
                    </div>)}
                </div>
            </div>
        </Modal>
    </Fragment>
}